import { useEffect, useCallback, useRef } from "react";
import getQueryString, { replaceQuery } from "libs/getQueryString";
// import { isLogin } from 'store/reducers/login';
import { get } from "lodash";
import Service from "services/wechat";
// import detectWX from "libs/detectWX";
import storage from "libs/storage";
// import detectBusinessWX from "libs/detectBusinessWX";
import { useDispatch } from "react-redux";
// import { message } from "antd";
import { useHistory } from "react-router-dom";

// const isWXEnv = detectWX() || detectBusinessWX();

// const wutianCompanyID = "102";

export function wutianAuthRedirect({
  key,
  secret,
}: {
  key: string | number;
  secret: string | number;
}) {
  // const domain = window.location.host;
  const domain = "wechat-test.takeda.com.cn";
  // const redirect_uri = encodeURIComponent(window.location.href);
  // const next = `${window.location.origin}/chatbot/#/login?companyID=${wutianCompanyID}`;
  const next = replaceQuery("secret", "", replaceQuery("key", ""));
  const redirect_uri = encodeURIComponent(next);
  let authUrl = `https://${domain}/OAuth2/GetUserInfoByAccessApp?key=${key}&secret=${secret}&redirectUrl=${redirect_uri}`;
  // alert(
  //   `domain: ${domain}; key: ${key}; secret: ${secret}; jump url: ${authUrl}`
  // );
  window.location.href = authUrl;
}

export function isLogin() {
  const token = storage.getToken();
  const isValidToken =
    token &&
    token !== "undefined" &&
    token !== "null" &&
    token !== "false" &&
    token !== "0" &&
    token !== "isNaN";
  if (!isValidToken) {
    storage.removeToken();
  }
  return !!isValidToken;
}

export default function useAutoMapUserToWX() {
  const history = useHistory();
  const loading = useRef(false);
  const dispatch = useDispatch();
  // const handleWXAuth = useCallback(async () => {
  //   if (loading.current) return;
  //   loading.current = true;
  //   const hide = message.loading({
  //     content: "登陆中...",
  //     key: wutianCompanyID,
  //     duration: 0,
  //   });
  //   try {
  //     const res = await Service.getWutianLoginConfig();
  //     const success = get(res, "code") === 200;
  //     const msg = get(res, "message", "获取登录配置失败");
  //     if (!success) {
  //       message.error(msg);
  //       return;
  //     }
  //     const key = get(res, "result.key");
  //     const secret = get(res, "result.secret");
  //     // const companyID = getQueryString("companyID");
  //     // const key = 'feN03o31tUKcUkAyx4VapQ';
  //     // const secret = 'QFlqAr3JrUWojEbxL6Jhg';
  //     console.log("key: ", key);
  //     console.log("secret: ", secret);
  //     // console.log("companyID: ", companyID);
  //     // alert(`测试用：key:${key}, secret: ${secret}`);
  //     if (
  //       !isLogin() &&
  //       isWXEnv &&
  //       key &&
  //       secret
  //       // companyID === wutianCompanyID
  //     ) {
  //       storage.setCompanyID(wutianCompanyID);
  //       wutianAuthRedirect({ key, secret });
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   } finally {
  //     loading.current = false;
  //     hide();
  //   }
  // }, []);

  const teamsLogin = useCallback(
    async ({
      teamsToken,
      companyID,
    }: {
      companyID: string;
      teamsToken: string;
    }) => {
      try {
        if (loading.current) return;
        loading.current = true;
        dispatch({
          type: "global/setLoading",
          payload: { status: true },
        });

        const res = await Service.teamsLogin({ token: teamsToken, companyID });
        const token = get(res, "result.token");
        // const companyID = get(res, "result.company_id", "") as any;
        // alert(`token: ${token}`);
        if (token) {
          storage.setToken(token);
          storage.setCompanyID(companyID);
          storage.setItem("isTeamsEnv", "true");
          storage.setItem("login-method", "takeda-teams");
          // window.location.href = replaceQuery("code", "");
          history.push("/chat");
        }
      } catch (e) {
        console.log(e);
      } finally {
        dispatch({
          type: "global/setLoading",
          payload: { status: false },
        });
        loading.current = true;
      }
    },
    [dispatch, history]
  );

  useEffect(() => {
    const teamsToken = getQueryString("teamsToken") as any;
    const companyID = getQueryString("companyID") as any;
    if (teamsToken && companyID) {
      storage.setCompanyID("");
      storage.setToken("");
      teamsLogin({ teamsToken, companyID });
    } else {
      storage.setItem("isTeamsEnv", "false");
    }
  }, [teamsLogin]);
}
